module.exports = __webpack_public_path__ + "img/diagnostic-blank.233b8579.png";